/* Analysis */
export const GET_ANALYSIS = "GET_ANALYSIS";
export const GET_ANALYSIS_SUCCESS = "GET_ANALYSIS_SUCCESS";
export const GET_ANALYSIS_ERROR = "GET_ANALYSIS_ERROR";

export const GET_ANALYSES = "GET_ANALYSES";
export const GET_ANALYSES_SUCCESS = "GET_ANALYSES_SUCCESS";
export const GET_ANALYSES_ERROR = "GET_ANALYSES_ERROR";

export const ADD_ANALYSIS = "ADD_ANALYSIS";
export const ADD_ANALYSIS_SUCCESS = "ADD_ANALYSIS_SUCCESS";
export const ADD_ANALYSIS_ERROR = "ADD_ANALYSIS_ERROR";

export const MODIFY_ANALYSIS = "MODIFY_ANALYSIS";
export const MODIFY_ANALYSIS_SUCCESS = "MODIFY_ANALYSIS_SUCCESS";
export const MODIFY_ANALYSIS_ERROR = "MODIFY_ANALYSIS_ERROR";

export const DELETE_ANALYSIS = "DELETE_ANALYSIS";
export const DELETE_ANALYSIS_SUCCESS = "DELETE_ANALYSIS_SUCCESS";
export const DELETE_ANALYSIS_ERROR = "DELETE_ANALYSIS_ERROR";

/* Analysis Team Permissions */
export const GET_ANALYSIS_TEAM = "GET_ANALYSIS_TEAM";
export const GET_ANALYSIS_TEAM_SUCCESS = "GET_ANALYSIS_TEAM_SUCCESS";
export const GET_ANALYSIS_TEAM_ERROR = "GET_ANALYSIS_TEAM_ERROR";

export const GET_ANALYSIS_TEAMS = "GET_ANALYSIS_TEAMS";
export const GET_ANALYSIS_TEAMS_SUCCESS = "GET_ANALYSIS_TEAMS_SUCCESS";
export const GET_ANALYSIS_TEAMS_ERROR = "GET_ANALYSIS_TEAMS_ERROR";

export const ADD_ANALYSIS_TEAM = "ADD_ANALYSIS_TEAM";
export const ADD_ANALYSIS_TEAM_SUCCESS = "ADD_ANALYSIS_TEAM_SUCCESS";
export const ADD_ANALYSIS_TEAM_ERROR = "ADD_ANALYSIS_TEAM_ERROR";

export const DELETE_ANALYSIS_TEAM = "DELETE_ANALYSIS_TEAM";
export const DELETE_ANALYSIS_TEAM_SUCCESS = "DELETE_ANALYSIS_TEAM_SUCCESS";
export const DELETE_ANALYSIS_TEAM_ERROR = "DELETE_ANALYSIS_TEAM_ERROR";
